<template>
  <b-input-group class="location-input">
    <b-input-group-text class="location-text" :class="{ 'border-danger': state == false, 'border-success': state == true }">{{ humanReadable }}</b-input-group-text>
    <b-input-group-append>
      <b-button :variant="state == true ? 'success' : state == false ? 'danger' : 'primary'" @click="onSearchClick">
        <b-icon icon="geo" />
      </b-button>
    </b-input-group-append>
    <b-modal
      ref="modal"
      size="lg"
      body-class="p-0 border-0"
      footer-class="border"
      hide-header
      :ok-disabled="markerPosition == null"
      :ok-title="$t('ok')"
      :cancel-title="$t('cancel')"
      @ok="onOkClick"
      @cancel="onCancelClick"
    >
      <div style="height: min(50vh, 400px); width: 100%;">
        <l-map
          ref="map"
          :zoom="10"
          :center="coordinates"
          @ready="fixSizeProblem"
          @click="onMapClick"
          style="cursor: pointer;"
        >
          <v-geosearch :options="geosearchOptions"></v-geosearch>
          <l-tile-layer :url="$t('map.tiles')"></l-tile-layer>
          <l-marker v-if="markerPosition" :lat-lng="markerPosition"></l-marker>
        </l-map>
      </div>
    </b-modal>
  </b-input-group>
</template>
<script>
const OSM_API_URL = "https://nominatim.openstreetmap.org/reverse?format=jsonv2";

import { OpenStreetMapProvider } from "leaflet-geosearch";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import VGeosearch from "vue2-leaflet-geosearch";
import { latLng } from "leaflet";
import "leaflet-geosearch/dist/geosearch.css";

export default {
  components: {
    LMap,
    LTileLayer,
    VGeosearch,
    LMarker,
  },
  props: ["value", "state"],
  data: () => ({
    coordinates: latLng(50.977357, 7.575606),
    geosearchOptions: {
      provider: new OpenStreetMapProvider(),
      autoClose: false,
      showMarker: true,
      maxMarkers: 1,
    },
    tempLocation: null,
  }),
  computed: {
    humanReadable() {
      if (this.value == null) return "-";
      else
        return `${this.value.city}, ${this.value.countryCode?.toUpperCase()}`;
    },
    markerPosition() {
      return this.tempLocation
        ? this.tempLocation
        : this.value?.coordinates
        ? latLng(this.value.coordinates.lat, this.value.coordinates.lon)
        : null;
    },
  },
  methods: {
    onSearchClick() {
      this.$refs.modal.show();
    },
    async onMapClick(event) {
      if (
        event.originalEvent.srcElement.className.includes("leaflet-bar-part") ||
        event.originalEvent.srcElement.className.includes("glass") ||
        event.originalEvent.srcElement.className.includes("reset")
      )
        return;
      this.tempLocation = event.latlng;
    },
    onCancelClick() {
      this.tempLocation = null;
    },
    async onOkClick() {
      const res = await fetch(
        `${OSM_API_URL}&lat=${this.tempLocation.lat}&lon=${this.tempLocation.lng}&accept-language=de`
      );

      if (res.ok) {
        const data = await res.json();
        this.$emit("input", {
          city: data.address.city || data.address.town || data.address.village,
          countryCode: data.address.country_code,
          coordinates: {
            lat: parseFloat(data.lat),
            lon: parseFloat(data.lon),
          },
        });
      }
      this.tempLocation = null;
    },
    fixSizeProblem() {
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize();
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.location-input {
  display: flex;
  flex-wrap: nowrap;
  .location-text {
    flex-grow: 2;
    cursor: default;
  }
}
</style>